import type { DeleteActionResponse } from '@/domains/academicRisk/academicRiskAction.entity';
import type { AcademicRiskActionRepository } from '@/domains/academicRisk/academicRiskAction.repository';

/**
 * Use Case para eliminar una acción académica existente del sistema.
 *
 * Funcionalidad:
 * - Elimina una acción académica previamente registrada
 * - Realiza eliminación en cascada de la acción y su incorporación asociada
 * - Persiste los cambios mediante el repositorio
 *
 * Responsabilidades:
 * - Validar el código de incorporación de acción antes de eliminar
 * - Coordinar la eliminación con el repositorio
 * - Manejar eliminación en cascada de registros relacionados
 * - Actuar como intermediario entre dominio e infraestructura
 */
export class DeleteAcademicRiskActionUseCase {
  private repository: AcademicRiskActionRepository;

  /**
   * Inicializa el UseCase con las dependencias necesarias.
   *
   * @param repository - Repositorio que implementa AcademicRiskActionRepository para operaciones CRUD de acciones
   */
  constructor(repository: AcademicRiskActionRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta la eliminación de una acción académica y su incorporación asociada.
   *
   * @param cod_incorporacion_accion - Código único de la incorporación de acción a eliminar
   */
  async execute(
    cod_incorporacion_accion: number,
  ): Promise<DeleteActionResponse> {
    return await this.repository.deleteAction(cod_incorporacion_accion);
  }
}
